import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.updateFeedingDistribution.try: {
            return state;
        }

        case constants.updateFeedingDistribution.success: {
            return action.payload;
        }

        case constants.updateFeedingDistribution.error: {
            return state;
        }

        default:
            return state;
    }
}
